<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <SpecialMemberTable />
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import SpecialMemberTable from './SpecialMemberTable.vue'

  export default {
    name: 'whitelist',
    components: {SpecialMemberTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/jeetPrivilege/cashback/specialMember/SpecialMember.vue